var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplayPlayer = function SvgReplayPlayer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8881 5.08039C14.0181 4.82039 13.0581 4.65039 11.9981 4.65039C7.20813 4.65039 3.32812 8.53039 3.32812 13.3204C3.32812 18.1204 7.20813 22.0004 11.9981 22.0004C16.7881 22.0004 20.6681 18.1204 20.6681 13.3304C20.6681 11.5504 20.1281 9.89039 19.2081 8.51039",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1283 5.32L13.2383 2",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1317 5.32031L12.7617 7.78031",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplayPlayer);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljg4ODEgNS4wODAzOUMxNC4wMTgxIDQuODIwMzkgMTMuMDU4MSA0LjY1MDM5IDExLjk5ODEgNC42NTAzOUM3LjIwODEzIDQuNjUwMzkgMy4zMjgxMiA4LjUzMDM5IDMuMzI4MTIgMTMuMzIwNEMzLjMyODEyIDE4LjEyMDQgNy4yMDgxMyAyMi4wMDA0IDExLjk5ODEgMjIuMDAwNEMxNi43ODgxIDIyLjAwMDQgMjAuNjY4MSAxOC4xMjA0IDIwLjY2ODEgMTMuMzMwNEMyMC42NjgxIDExLjU1MDQgMjAuMTI4MSA5Ljg5MDM5IDE5LjIwODEgOC41MTAzOSIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuMTI4MyA1LjMyTDEzLjIzODMgMiIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuMTMxNyA1LjMyMDMxTDEyLjc2MTcgNy43ODAzMSIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";